import React from 'react';
import { Box, Flex, Text, TextProps, BoxProps } from '../../primitives';
import { Icon, icons, IconProps } from '../icon';
import { Trans } from 'react-i18next';

type Props = {
  iconName: typeof icons[number];
  list: string[];
  iconPosition?: 'start' | 'center' | 'end';
  dangerouslySetInnerHTML?: boolean;
  colorText?: string;
  styleIcon?: Omit<IconProps, 'name'>;
  styleText?: Omit<TextProps, 'color'>;
  styleWrapper?: Omit<BoxProps, 'color'>;
};

export const ListIcon = ({
  iconName,
  list,
  colorText = 'primary',
  iconPosition = 'center',
  dangerouslySetInnerHTML = false,
  styleIcon,
  styleText,
  styleWrapper,
}: Props) => (
  <Box {...styleWrapper}>
    {list.map((text, index) => (
      <Flex alignItems={iconPosition} mb="medium" key={`list-icon-${index}`}>
        <Icon
          name={iconName}
          color="accent"
          mr="small"
          size={20}
          {...styleIcon}
        />

        {dangerouslySetInnerHTML ? (
          <Box color={colorText} {...styleText}>
            {/* We use Trans because sometimes "text" contains <strong> tag in i18n locales */}
            <Trans>{text}</Trans>
          </Box>
        ) : (
          <Text color={colorText} {...styleText}>
            {text}
          </Text>
        )}
      </Flex>
    ))}
  </Box>
);
